import countryCodes from './countryCodes.json';

export const getCountryLogo = (countryCode: string) => {
  return `https://cdn.sportmonks.com/images/countries/png/short/${countryCodes[countryCode]}.png`;
};
